import "../../../css/CenterLoader.css";

const CenterLoader = () => {
    return (
        <div className="center-loader holder">
            <div className="preloader">
                <div></div> <div></div> <div></div> <div></div> <div></div>{" "}
                <div></div> <div></div> <div></div> <div></div> <div></div>
            </div>
        </div>
    );
};

export default CenterLoader;
